const BaseUrl = 'https://dev.gateway-prospectos.srv1954566.hstgr.cloud/api';

export const environment = {
  production: false,
  loginUrl: 'https://dev.srv1954566.hstgr.cloud/',
  /**
   * El servicio de IDENTIDAD, que contesta `GET /sesion/actual` y
   * `POST /sesion/elegir-acceso`. Lo consume `proveerSesion` en `app.config.ts`.
   */
  identidadUrl: 'https://dev.srv1954566.hstgr.cloud/api/v1',
  BaseUrl,
  fileManagerSystemId: 1,
  googleClientId: '696344106549-nub0a80c3bvifi99v7b25hqiod0bh7n7.apps.googleusercontent.com',
  googleCalendarApiKey: 'AIzaSyC2fV9PKJE43W1gnRZNen2lxU6cCGCWwp8',
  googleCalendarId: 'c_3e53bb0b3b62dde012eba25406a25a6054ffcdc70d09ac8b9c6c49f36680d751@group.calendar.google.com',
  /** Webhook n8n para procesar CIF (PDF/imagen → JSON). */
  cifEndpoint: 'https://intellishs.app.n8n.cloud/webhook/<__PLACEHOLDER_VALUE__api/procesar-cif__>',
  cifApiKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3NzY4OTUwNzgsImV4cCI6MTc3Njg5ODY3OH0.ND-aYJOBR_C7ATpG7syioa-8VC557W0DVaFmhzIfWzE',
};
